import React, {useState, useEffect} from 'react';
import {injectStripe} from 'react-stripe-elements';
import CardSection from './CardSection';
import {PulseLoader} from 'react-spinners';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {TitleButton, CancelButton} from '../../../common/components/StyledComp';
import {Alert} from 'react-bootstrap';

const StripeAddPaymentMethod = ({mutation, stripe, elements, t, userId, onComplete, onCancel, onStart, onError, disabled}) => {

  const [stripeLoading, setStripeLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (stripe && elements) {
      setStripeLoading(false);
    }
  }, [stripe, elements]);

  const handleSubmit = (event, mutation) => {
    event.preventDefault();
    if (disabled) {
      return;
    }
    onStart();
    setStripeLoading(true);
    setError(false);
    setErrorMessage(null);
    stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement('card'),
    }).then(({paymentMethod, error}) => {
      if (error) {
        console.error(error);
        setError(true);
        setStripeLoading(false);
        setErrorMessage(error.message || null);
        onError();
      } else {
        mutation({
          variables: {
            userId,
            paymentMethodId: paymentMethod.id,
          },
        }).then((...args) => {
          setError(false);
          onComplete(...args);
        }).catch(error => {
          console.error(error);
          setError(true);
          onError();
        });
      }
    }).catch(error => {
      console.error(error);
      setError(true);
      setStripeLoading(false);
      setErrorMessage(error.message || null);
      onError();
    });
  };

  return (
    <form onSubmit={event => handleSubmit(event, mutation)}>
      <CardSection/>
      {error && (
        <Alert variant={'danger'}>{errorMessage ? errorMessage : t('unknownError')}</Alert>
      )}
      <div className="popin-buttons">
        {stripeLoading ? (
          <PulseLoader/>
        ) : (
          <>
            <TitleButton disabled={disabled} type="submit">{t('validate')}</TitleButton>
            <CancelButton type="button" onClick={onCancel} style={{marginTop: 0, width: 'auto'}}>{t('cancel')}</CancelButton>
          </>
        )}
      </div>
    </form>
  );
};

StripeAddPaymentMethod.defaultProps = {
  onComplete: () => {},
  onCancel: () => {},
  onStart: () => {},
  onError: () => {},
  disabled: false,
};

export const parentPropTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
  onStart: PropTypes.func,
  onError: PropTypes.func,
  disabled: PropTypes.bool,
};

StripeAddPaymentMethod.propTypes = {
  stripe: PropTypes.object,
  elements: PropTypes.object,
  t: PropTypes.func.isRequired,
  mutation: PropTypes.func.isRequired,
  ...parentPropTypes,
};

export default compose(
  injectStripe,
  withTranslation('stripe'),
)(StripeAddPaymentMethod);
